class Cookie {
  constructor() {}
  getCookie(name) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  }
  setCookie({
    name,
    value,
    days
  }) {
    let expires = null;
    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = `; expires=${date.toGMTString()}`;
    } else {
      expires = "";
    }
    console.log(expires);
    document.cookie = `${name}=${value + expires}; path=/`;
  }
}
const cookie = new Cookie();
export default cookie;